// import { getFileByPath, getFilesData } from "api/fileManager";
import dangerModalApiConfig from "./modal/DangerModal/config/dangerModalApiConfig";

const fileExplorerConfig = {
  getFilesData: () => null,
  getFileByPath: () => null,
  dangerModalApiConfig
};

export default fileExplorerConfig;